import { createIcon } from '../shared'

const CommentIcon = createIcon(
  ({ color }) => (
    <path
      d="M10.5407 1.92114C13.5271 1.92119 15.9482 4.34224 15.9482 7.32869C15.9482 9.28815 14.9732 11.1194 13.3477 12.2135L7.93555 15.856V12.7362H5.45052C2.4641 12.7362 0.0430784 10.3151 0.0429688 7.32869C0.0429688 4.34221 2.46403 1.92114 5.45052 1.92114H10.5407ZM5.45052 3.92114C3.5686 3.92114 2.04297 5.44678 2.04297 7.32869C2.04308 9.21052 3.56867 10.7362 5.45052 10.7362H9.93555V12.0989L12.2308 10.5543C13.3042 9.83185 13.9482 8.62255 13.9482 7.32869C13.9482 5.44681 12.4226 3.92119 10.5407 3.92114H5.45052ZM9.98698 8.83065H5.04297V7.77498H9.98698V8.83065ZM11.0052 6.90487H5.04297V5.8492H11.0052V6.90487Z"
      fill={color}
    />
  ),
  '0 0 16 16',
  'CommentIcon',
)

export { CommentIcon }
